import { render, staticRenderFns } from "./ProdutoList.vue?vue&type=template&id=032e81c0"
import script from "./ProdutoList.vue?vue&type=script&lang=js"
export * from "./ProdutoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports